//#region imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DetailsRoutingModule } from './details-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DetailsComponent } from './components/details/details.component';
import { DetailsQuestion1Component } from './components/details-question1/details-question1.component';
import { DetailsQuestion2Component } from './components/details-question2/details-question2.component';
import { DetailsQuestion3Component } from './components/details-question3/details-question3.component';
import { DetailsQuestion4Component } from './components/details-question4/details-question4.component';
import { DetailsQuestion5Component } from './components/details-question5/details-question5.component';
import { DetailsQuestion6Component } from './components/details-question6/details-question6.component';
import { DetailsQuestion7Component } from './components/details-question7/details-question7.component';
import { DetailsQuestion8Component } from './components/details-question8/details-question8.component';
import { DetailsQuestion9Component } from './components/details-question9/details-question9.component';
import { DetailsQuestion10Component } from './components/details-question10/details-question10.component';
import { DetailsQuestion11Component } from './components/details-question11/details-question11.component';
import { DetailsQuestion12Component } from './components/details-question12/details-question12.component';
import { MatButtonModule, MatFormFieldModule, MatRippleModule, MatInputModule, MatAutocomplete, MatSelectModule, MatAutocompleteModule } from '@angular/material';
//#endregion

@NgModule({
  declarations: [
    DetailsComponent,
    DetailsQuestion1Component, DetailsQuestion2Component, DetailsQuestion3Component,
    DetailsQuestion4Component, DetailsQuestion5Component, DetailsQuestion6Component,
    DetailsQuestion7Component, DetailsQuestion8Component, DetailsQuestion9Component,
    DetailsQuestion10Component, DetailsQuestion11Component, DetailsQuestion12Component
  ],
  imports: [
    CommonModule, FormsModule, SharedModule, DetailsRoutingModule, ReactiveFormsModule,
    MatFormFieldModule, MatInputModule,
    MatSelectModule, MatAutocompleteModule
  ],
  exports: [
    DetailsComponent,
    DetailsQuestion1Component, DetailsQuestion2Component, DetailsQuestion3Component,
    DetailsQuestion4Component, DetailsQuestion5Component, DetailsQuestion6Component,
    DetailsQuestion7Component, DetailsQuestion8Component, DetailsQuestion9Component,
    DetailsQuestion10Component, DetailsQuestion11Component, DetailsQuestion12Component
  ]
})
export class DetailsModule { }
